  /**
   * @class portalConfig
   * @static
   *
   * portalConfig is an object that we use to generate the
   * navigation items in portalNavView (which extends
   * mainNavView). It sets all of our options for navigation.
   */
var portalConfig = {};

portalConfig.pageItems = {
  addStoredPaymentMethod: {
    id: 'add-stored-payment-method',
    name: 'Add Stored Payment Method'
  },
  appointments: {
    id: 'appointments',
    name: 'Appointments'
  },
  bills: {
    id: 'bills',
    name: 'Bills'
  },
  dashboard: {
    id: 'dashboard',
    name: 'Dashboard'
  },
  logout: {
    id: 'logout',
    name: 'Sign Out'
  },
  profile: {
    id: 'profile',
    name: 'Profile'
  },
  settings: {
    id: 'settings',
    name: 'Settings'
  }
};

portalConfig.navItems = [
  {
    name: portalConfig.pageItems.dashboard.name,
    id: portalConfig.pageItems.dashboard.id,
    icon: 'icon-home',
    dropdownId: 'dropdown-menu-dashboard',
    subitems: [
      {
        name: portalConfig.pageItems.dashboard.name,
        link: '#patient/158DE262-FDEB-43F2-85F1-A94F09A6A9A6',
        icon: 'icon-user'
      },
      {
        name: portalConfig.pageItems.profile.name,
        link: '#portal/profile',
        icon: 'icon-user'
      },
      {
        name: portalConfig.pageItems.settings.name,
        link: '#patient/158DE262-FDEB-43F2-85F1-A94F09A6A9A6/settings',
        icon: 'icon-cog'
      }
    ]
  },
  {
    name: portalConfig.pageItems.appointments.name,
    id: portalConfig.pageItems.appointments.id,
    link: '#patient/158DE262-FDEB-43F2-85F1-A94F09A6A9A6/appointment',
    icon: 'icon-calendar'
  },
  {
    name: portalConfig.pageItems.bills.name,
    id: portalConfig.pageItems.bills.id,
    link: '#patient/158DE262-FDEB-43F2-85F1-A94F09A6A9A6/bill',
    icon: 'icon-dollar-sign'
  }
];

portalConfig.secondaryNavItems = [
  {
    name: portalConfig.pageItems.logout.name,
    id: portalConfig.pageItems.logout.id,
    link: '#portal/logout',
    icon: 'icon-signout'
  },
];

module.exports = portalConfig;
